export const LOCATION_ENTRY = 'location-entry';
export const LOCATION_PASS_BY = 'location-pass-by';
